export default __webpack_public_path__ + "static/media/view_eye.c1685c89.svg";